// src/utils/contactService.js

/**
 * Send contact form data to Firebase function
 * @param {Object} formData - The form data to send
 * @returns {Promise} - The response from the Firebase function
 */
export const sendContactForm = async (formData) => {
  // Updated function URL - this is the new 2nd Gen Cloud Function URL
  const functionUrl = 'https://sendcontactemail-6zbb4skvsa-ew.a.run.app';
  
  try {
    console.log('Sending form data to Firebase function:', functionUrl);
    
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    const responseData = await response.json();
    
    if (!response.ok) {
      console.error('Server error:', responseData);
      throw new Error(responseData.error || 'Failed to send message');
    }
    
    console.log('Form submission successful:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error sending contact form:', error);
    throw error;
  }
};